import React from "react";
export default () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.6808 5.57346C22.8679 5.84079 23.1737 6 23.5 6C23.8263 6 24.1321 5.84079 24.3192 5.57346L27.5207 1H31V14H28V9C28 8.54823 27.6971 8.15256 27.261 8.03466C26.8249 7.91675 26.3639 8.1059 26.1362 8.49613L23.5 13.0154L20.8638 8.49613C20.6361 8.1059 20.1751 7.91675 19.739 8.03466C19.3029 8.15256 19 8.54823 19 9V14H16V1H19.4793L20.2986 0.426538L19.4793 1L22.6808 5.57346Z"
      stroke="#757575"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M6 31V18L12.9248 18L15 19.5092V29.4908L12.9248 31H6Z"
      stroke="#757575"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.9142 21H9.25C9.11193 21 9 21.1119 9 21.25V27.75C9 27.8881 9.11193 28 9.25 28H10.9142C10.9698 28 11.0238 27.9815 11.0677 27.9473L11.9035 27.2973C11.9644 27.2499 12 27.1771 12 27.1V21.9C12 21.8229 11.9644 21.7501 11.9035 21.7027L11.0677 21.0527C11.0238 21.0185 10.9698 21 10.9142 21Z"
      stroke="#757575"
      stroke-width="2"
    />
    <path
      d="M23.75 27H22.25C22.1119 27 22 27.1119 22 27.25V27.75C22 27.8881 22.1119 28 22.25 28H23.75C23.8881 28 24 27.8881 24 27.75V27.25C24 27.1119 23.8881 27 23.75 27Z"
      stroke="#757575"
      stroke-width="2"
    />
    <path
      d="M3.99999 1H8.99999H12V4H9.24999C8.55964 4 7.99999 4.55964 7.99999 5.25V14H4.99999V5.25C4.99999 4.55964 4.44035 4 3.74999 4H1L1 1L3.99999 1Z"
      stroke="#757575"
      stroke-width="2"
    />
    <path
      d="M19 31V18L22 18V22C22 23.1046 22.8954 24 24 24H27V31H19Z"
      stroke="#757575"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
